import { type SendAnalyticsEvent } from '@atlassian/conversation-assistant-instrumentation/types/analytics';

import { type AgentMentionConversationContext } from '../types';

type AgentMentionDismissedAnalyticsPayload = Pick<
	AgentMentionConversationContext,
	'conversationAgentId'
> & {
	agentId: string;
	selectedAgentCountBeforeDismiss: number;
	sendAnalyticsEvent: SendAnalyticsEvent;
};

export const sendAgentMentionDismissedAnalyticsEvent = ({
	agentId,
	selectedAgentCountBeforeDismiss,
	conversationAgentId,
	sendAnalyticsEvent,
}: AgentMentionDismissedAnalyticsPayload): void => {
	sendAnalyticsEvent({
		action: 'dismissed',
		actionSubject: 'mentionAgent',
		eventType: 'ui',
		attributes: {
			agentId,
			source: 'inputHat',
			selectedAgentCountBeforeDismiss,
			remainingSelectedAgentCount: Math.max(selectedAgentCountBeforeDismiss - 1, 0),
			...(conversationAgentId ? { conversationAgentId } : {}),
		},
	});
};
